// extracted by mini-css-extract-plugin
export default {"cls1":"A4gF6h5h95RKd594P92z","cls2":"_NzJ1LuJcxJcIBCgsKtr A4gF6h5h95RKd594P92z"};